<!-- 
程式：CarReserveModal.vue
功能：車險預約單明細
作者：i9400520
完成：2019-01-07
-->
<template>
  <div class="modal fade" :class="{'is-open': open}">
    <div class="modal-dialog" style="width: 926px;">
      <div v-if="open" class="modal-content" :class="{'section-loading': isDataLoading}">
        <div class="modal-header">
          <a class="close" @click="$emit('close')">
            <i class="icon-close"></i>
          </a>
        </div>
        <div class="modal-body">
          <table class="table insurance-green">
            <tr>
              <th class="text-green text-right" width="120">通訊地址</th>
              <td>{{infoAddr}}</td>
            </tr>
            <tr>
              <th class="text-green text-right" width="120">電子郵件</th>
              <td></td>
            </tr>
          </table>
          <br>
          <table class="table insurance-green">
            <tr>
              <th class="text-green">車牌號碼</th>
              <th class="text-green">
                強制險
                <br>到期日
              </th>
              <th class="text-green">
                原始
                <br>發照日
              </th>
              <th class="text-green">
                製造
                <br>年月
              </th>
              <th class="text-green">
                廠牌
                <br>型式
              </th>
              <th class="text-green">車種</th>
              <th class="text-green">排氣量</th>
              <th class="text-green">
                引擎
                <br>號碼
              </th>
              <th class="text-green">
                乘載
                <br>限制
              </th>
              <th class="text-green">
                欲投保
                <br>險種
              </th>
            </tr>
            <tr v-for="(item, index) in infoDetail" :key="index">
              <td>{{item.car_id || ''}}</td>
              <td>{{item.car_insur_date || ''}}</td>
              <td>{{item.car_issue_date || ''}}</td>
              <td>{{item.crr_make_month || ''}}</td>
              <td>{{item.crr_brand || ''}}</td>
              <td>{{item.crr_kind || ''}}</td>
              <td>{{item.crr_cc || ''}}</td>
              <td>{{item.crr_engin || ''}}</td>
              <td>{{item.crr_lvup || ''}}</td>
              <td></td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CarReserveModal",
  props: {
    open: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    detailData: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      isDataLoading: false,
      infoDetail: {},
      infoAddr: ""
    };
  },
  watch: {
    detailData: "syncDataFromSuperComponent",
    loading: "syncDataFromSuperComponent"
  },
  methods: {
    syncDataFromSuperComponent() {
      this.isDataLoading = this.loading;
      this.infoDetail = this.detailData;
      if (this.infoDetail && this.infoDetail.length > 0) {
        this.infoAddr = this.infoDetail[0].c_addr;
      } else {
        this.infoAddr = "";
      }

      this.registerHanlink(); // for hard word
    }
  }
};
</script>